import React from 'react';
import RatingStar from '../../visuals/Icons/RatingStar';
import RatingStarEmpty from '../../visuals/Icons/RatingStarEmpty';
import { IconSizes } from '../../visuals/Icons/type';

interface IReviewStarsProps {
  averageRating: number;
  size?: IconSizes;
  UNSAFE_className?: string;
}

const ReviewStars: React.FC<IReviewStarsProps> = ({
  averageRating,
  size = IconSizes.sm,
  UNSAFE_className = '',
}) => {
  const allStars = [...Array(5).keys()];
  const ratingPercentage = (100 * averageRating) / 5;

  return (
    <span
      className={`tw-relative tw-inline-block tw-whitespace-nowrap ${UNSAFE_className}`}
      aria-hidden="true"
    >
      {allStars.map((index) => {
        return <RatingStarEmpty size={size} key={index} />;
      })}

      <span
        className="tw-absolute tw-left-0 tw-top-0 tw-overflow-hidden"
        style={{ width: `${ratingPercentage}%` }}
      >
        {allStars.map((index) => {
          return <RatingStar size={size} key={index} />;
        })}
      </span>
    </span>
  );
};

export default ReviewStars;
